import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnsFinishedSales } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import ViewSalesModal from '@components/Modal/ViewSalesModal/index'
import { useQuery } from '@tanstack/react-query'
import { fetchSalesFinished } from '@utils/fetchData'
import { debouncedSet } from '@utils/debounce'
import { useSelector } from 'react-redux'
import {
	handleNavigateFinishedSales,
	handleNavigateCarFinishedSales,
	handleNavigateSeries,
} from '@utils/navigateToPdf'
import { changePageSize, changePagination } from '@utils/pagination'

const FinishedSales = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()
	const { department, roleNames } = useSelector((state) => state.main)

	const [currentPage, setCurrentPage] = useState(0)
	const [pageSize, setPageSize] = useState(10)

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)

	const { data = [], isLoading } = useQuery({
		queryKey: [
			'finishedSales',
			currentPage,
			cardName,
			docNum,
			startDate,
			endDate,
			slpName,
			roleNames.includes('Supplier') || roleNames.includes('admin')
				? ''
				: department,
			'api/sales/tugallangan-sotuvlar',
			pageSize,
		],
		queryFn: fetchSalesFinished,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handleSlpNameChange = (val) => {
		debouncedSet(val, setSlpName)
	}

	const columns = columnsFinishedSales(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		handleSlpNameChange,
		handleNavigateFinishedSales,
		handleNavigateCarFinishedSales,
		handleNavigateSeries,
	)

	const handlePaginationChange = (page, pageSize) => {
		changePagination({
			page,
			pageSize,
			setCurrentPage,
			setPageSize,
		})
	}
	const handlePageSizeChange = (current, pageSize) => {
		changePageSize({
			current,
			pageSize,
			setCurrentPage,
			setPageSize,
		})
	}

	return (
		<Layout>
			<Header
				title={t('finishedSales')}
				isShowPagination
				handlePageSizeChange={handlePageSizeChange}
				handlePaginationChange={handlePaginationChange}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
			/>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				isFinishedSalesMenu
			/>
		</Layout>
	)
}

export default FinishedSales
